import { slugify } from "../../utils/slugify.js";
import { Locale, type LocalizedString } from "../Locale.js";
import type { Subcategory } from "../Subcategory.js";
import type { Tenant } from "../Tenant.js";
import { categoryNameMap } from "../names/categoryNameMap.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getSubcategoryPath(tenant: Tenant, subcategory: Subcategory): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: `/${slugify(categoryNameMap[subcategory.category][Locale.cs])}/${slugify(subcategory.name[Locale.cs])}`,
	};

	return getPathInLocale(tenant.locale, pathMap);
}
